import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>
        <div className="privacy-content">
          <p>
            This site is part of the Adam Alchemy Records Archive project. We value your privacy as much as we value musical history and storytelling. If you contact us via email, your information is used solely for communication regarding the Archive and The Snow Flowerz. We do not sell, trade, or share your data with third parties. This site may use basic cookies to ensure a smooth browsing experience. For any inquiries regarding your data, please contact - alchemyadam@gmail.com
          </p>
        </div>
        <Link to="/#footer" className="back-btn">Back</Link>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
